import type { ConfigContract } from "../types";

export default {
  TAMEENI_HOME: "https://pre.tameeni.com",
  API_BASE_URL: "https://pre-travel.tameeni.com/backend/api/v1/",
  CONNECTION_API_URL: "https://pre-travel.tameeni.com/backend/QuoteNotifierHub",
  AMEEN_URL: "https://qcmotor.gettameeni.com/ameen",
  IDENTITY_URL: "https://preidentity.tameeni.com/",
  IDENTITY_CLIENT_ID: "Travel_Preprod",
  IDENTITY_CLIENT_SECRET: "Secret12345",
  IDENTITY_REDIRECT_URL: "https://pre-travel.tameeni.com",
  APP_URL: "https://pre-travel.tameeni.com/",
  OTP_TIMER: 3,
  SESSION_MAX_AGE: 10 * 24 * 60 * 60,
  IS_LOGIN_ENFORCE: true,
  NEXT_PUBLIC_APP_ENV: "preprod",
  FILTER_MIN_QUOTATIONS: 4,
} satisfies ConfigContract;
